import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName"];
import { useTheme } from 'foundations-theming/utils';
import { AbstractTextElement } from '../AbstractTextElement';
import { SmallContextProvider } from './SmallContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const Small = _ref => {
  let {
      tagName = 'small'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(SmallContextProvider, {
    abstractTextElementStyleOverrides: {
      fontSize: theme.typography['detail-200'].fontSize,
      lineHeight: theme.typography['detail-200'].lineHeight
    },
    children: /*#__PURE__*/_jsx(AbstractTextElement, Object.assign({
      tagName: tagName
    }, restProps))
  });
};